// Shared helpers for the LTI 1.3 dashboard components

export const getErrorMessage = (err, fallback) => {
  if (err.response && err.response.data && err.response.data.error) {
    return err.response.data.error
  }
  return fallback
}
